/// \file maintenancePlans.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const MaintenancePlansList = lazy(() => import('../views/maintenance-plans/list/view'));

async function maintenancePlansDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/maintenance-plans/list/loader')).default;
  return actualLoader(args);
}

export async function maintenancePlansAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/maintenance-plans/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="maintenancePlans"
    handle={{
      text:"MAINTENANCE PLANS"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <MaintenancePlansList />
        </Suspense>
      }
      loader={maintenancePlansDataLoader}
      action={maintenancePlansAction}
      />
  </Route>
);

export default routes;